import type { AnalyticsQuery, AnalyticsResult } from '@obras/shared';
import { useQuery } from '@tanstack/react-query';

import { api, queryString } from '../../lib/api.js';

const csv = (values: readonly string[] | undefined): string | undefined =>
  values && values.length > 0 ? values.join(',') : undefined;

/** Os mesmos filtros da tela, na URL — o PDF sai do recorte que está à vista. */
export function analyticsQueryString(filters: Partial<AnalyticsQuery>): string {
  return queryString({
    from: filters.from,
    to: filters.to,
    fiscalIds: csv(filters.fiscalIds),
    companyIds: csv(filters.companyIds),
    secretariaIds: csv(filters.secretariaIds),
    statuses: csv(filters.statuses),
  });
}

export function useAnalytics(filters: Partial<AnalyticsQuery>) {
  return useQuery({
    queryKey: ['analitico', filters],
    queryFn: ({ signal }) =>
      api.get<AnalyticsResult>(`/analitico${analyticsQueryString(filters)}`, signal),
    // Segura o resultado anterior enquanto revalida: sem piscar esqueleto.
    placeholderData: (previous) => previous,
  });
}
